import { Section } from "../../components/Section/Section";
import styles from "./Media.module.scss";
import { MediaOptionsType } from "@/types/ModuleOptionsType";
import { columnSize } from "../../utils/layout/columnSize";
import Media from "../../components/Media/Media";

import { ScaleUp } from "@/components/Animation";
import { Modul_Media } from "../../wp/types/acf-module-types";
import { useSublinesVisibility } from "../../hooks/useSublinesOverlinesVisibility";
import { checkModuleIsHidden } from "@/utils/checkModuleIsHidden";
import { Headline } from "@/components/Headline/Headline";

export type MediaModuleType = Modul_Media;

interface MediaProps {
  data: MediaModuleType;
  noSection?: boolean;
  mediaOptions: MediaOptionsType;
}

const MediaModul = ({ data, noSection, mediaOptions }: MediaProps) => {
  const {
    media_format: mediaFormat,
    columns,
    show_audio_icon: showAudioIcon,
    show_overline_subline,
    box: { show_border_radius, show_box_shadow, show_card_box },
    show_original_format,
  } = mediaOptions || {};
  const {
    section_padding_class,
    background_color_class,
    headline_text_align_class,
    id,
    module_width,
    keep_media_format,
  } = data.layout;
  const { headline_html_tag, headline, overline, subline } = data.media;
  const { showOverline, showSubline } = useSublinesVisibility(
    show_overline_subline ?? "none",
  );

  {
    /* jscpd:ignore-start */
  }
  //! check if module is hidden
  const isHidden = checkModuleIsHidden(data.settings);
  if (isHidden) {
    return null;
  }
  {
    /* jscpd:ignore-end */
  }

  if (noSection) {
    return (
      <Media
        mediaData={data.media.media}
        mediaFormat={mediaFormat}
        showAudioIcon={showAudioIcon}
        sectionBgColor={background_color_class ? background_color_class : ""}
      />
    );
  } else {
    return (
      <Section
        className={`${styles.media} ${background_color_class} ${section_padding_class} ${show_card_box && show_border_radius ? styles["has-border-radius"] : ""} ${show_card_box && show_box_shadow ? styles["has-box-shadow"] : ""}`}
        columnsClassName="is-centered"
        frameless={module_width === "frameless"}
        id={id}
      >
        <div
          className={`column ${module_width === "narrow-frame" ? columnSize(columns) : "is-12"} is-centered`}
        >
          <Headline
            headline_html_tag={headline_html_tag}
            headline={headline}
            extraClass={headline_text_align_class}
            subline={showSubline ? subline : ""}
            overline={showOverline ? overline : ""}
            wrapInSection={module_width === "frameless"}
            disableAnimation
          />
          <ScaleUp threshold={0.1}>
            <Media
              mediaData={data.media.media}
              mediaFormat={
                show_original_format && keep_media_format
                  ? undefined
                  : mediaFormat
              } // keep_media_format is used to keep the original media format
              showAudioIcon={showAudioIcon}
              sectionBgColor={
                background_color_class ? background_color_class : ""
              }
            />
          </ScaleUp>
        </div>
      </Section>
    );
  }
};

export default MediaModul;
